import { put, call } from 'redux-saga/effects';
import MulesoftDataService from './../../services/mulesoftData.services';
import { constants } from '../../constants';

import { 
  setTranscriptsSuccess,
  setTranscriptsError,
  toggleAlertShowStatus} from '../actions';


export default function * getTranscriptsCost (args) {
  try {
      const res = yield call([MulesoftDataService, 'getTranscriptsCost'],args.payload);
      //making sure redux store will update if api save is successful
      yield put(setTranscriptsSuccess(res.data.transcriptsCosts));
  } catch (error) {
    yield put(toggleAlertShowStatus({
      showAlert: true,
      alertVarient:'danger',
      alertMessage: constants.APP_MESSAGE.API_RETRIVE_ERROR
    }));

    yield put(setTranscriptsError()) 
  }
}
